export default __webpack_public_path__ + "static/linear-tablet-f04ba2aba399f1af42b5b3b3c6c98db9.jpg";